import React, { useEffect, useState } from 'react';
import { PaymentForm } from 'Forms/PaymentForm';
import { onSubmitReactFormError } from 'Utils/FormValidation';
import { updateCardPayment } from 'Api/EvergentApi';
import { PayPalButton } from 'Components/PayPal/PayPalButton';
import { setPaypalError } from 'State/Checkout';
import { paypalUpdatePaymentInfo } from 'Api/PayPal';
import { CenterFrameLayout } from 'Layouts';
import { tealiumTrackEvent, trackEvent, TRACKING_ENUMS } from 'Utils/Analytics';
import { clearPaymentMethods } from 'State/PaymentMethods/PaymentMethodActions';
import { useDispatch } from 'react-redux';
import { useNavigate } from 'react-router-dom';
import { usePayPal } from 'Hooks/usePayPal';
import { useStore } from 'Hooks/useStore';
import './EditPaymentContainer.css';
import { updateConfirmation } from 'State/Layout';

export const EditPaymentContainer = () => {
  const navigate = useNavigate();
  const [isUpdateCC, setUpdateCC] = useState(false);
  const dispatch = useDispatch();
  const routes = useStore('appConfig.routes');
  const [, paypalActions] = usePayPal();

  useEffect(() => {
    trackEvent(TRACKING_ENUMS.EVENT_EDIT_PAYMENT_INFO_SELECTED);
  }, []);

  const goToMyaccount = () => navigate(routes.myAccount);

  const handleUpdatePayment = async (data = {}) => {
    const { isSuccess, errorMessage } = await (isUpdateCC ? updateCardPayment() : paypalUpdatePaymentInfo(data));
    if (isSuccess) {
      updateConfirmation('Your payment method has been updated.');
      dispatch(clearPaymentMethods());
      tealiumTrackEvent(TRACKING_ENUMS.EVENT_EDIT_PAYMENT_INFO_COMPLETED, {
        button_text: 'Update Payment Method',
        button_location: 'my account',
      });
      trackEvent(TRACKING_ENUMS.EVENT_ACCOUNT_SETTING_PAYMENT_METHOD_UPDATED, {
        page_item_title: 'Update Payment Method',
      });
      goToMyaccount();
    } else {
      if (isUpdateCC) {
        return onSubmitReactFormError(errorMessage);
      } else {
        setPaypalError(errorMessage);
      }
      throw new Error(errorMessage);
    }
  };

  if (isUpdateCC) {
    return (
      <CenterFrameLayout title="Update Payment Information" goBack="Back to My Account" backUrl={routes.myAccount}>
        <div className="roundContentContainer">
          <p className="formText">Your new payment method will be applied to your next billing cycle.</p>
          <h3 className="formHeader">Credit / Debit Card</h3>
          <PaymentForm
            editForm
            onFormSubmit={() => handleUpdatePayment()}
            submitButtonText="Update Payment Method"
            showCancelButton
            onCancelClick={() => goToMyaccount()}
            updatePaymentServiceId="NONE"
          />
        </div>
      </CenterFrameLayout>
    );
  }

  return (
    <CenterFrameLayout title="Update Payment Information" goBack="Back to My Account" backUrl={routes.myAccount}>
      <div>
        <p className="editPaymentHeader">Your new payment method will be applied to your next billing cycle.</p>
        <p className="editPaymentSubheader">Select one payment method to continue.</p>
        <div className="paymentMethodsContainer">
          <button onClick={() => setUpdateCC(true)} className="ccButton" type="button">
            <span>Credit or Debit Card</span>
            <img
              className="ccImage"
              src="/account/static/images/cards/cards-group.jpg"
              width="280"
              height="25"
              alt="Credit or Debit Card"
            />
            <img
              className="paymentArrow"
              src="/account/static/images/chevron-grey.svg"
              width="30"
              height="30"
              alt="arrow"
            />
          </button>
          <div className="paypalButtonOuterContainer paypalPaymentMethod">
            <PayPalButton
              submitButtonText="Continue with PayPal"
              onClick={() => paypalActions.createAuthOrder()}
              onApprove={(data) => handleUpdatePayment(data)}
              onError={(error) => setPaypalError(error.message)}
              idName={'editPaymentPaypalButton'}
            />
          </div>
        </div>
      </div>
    </CenterFrameLayout>
  );
};
